<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-19 15:14:05
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-19 19:35:59
 * @FilePath: \hzs-nutra-wecom-shop\src\views\customer\customerTagsEdit.vue
 * @Description: 编辑标签
-->
<template>
  <div class="page-container">
    <div class="mainContent">
      <div
        v-for="item in state.tagLists"
        :key="item.category_uuid"
        class="tags"
      >
        <p class="_categoryName">{{ item.name }}</p>

        <ul class="tagList flex align-center flex-wrap">
          <li
            v-for="item2 in item.tags"
            :key="item2.tag_uuid"
            class="tagItem"
            :class="
              state.currentTagIds.includes(item2.tag_uuid) ? 'active' : ''
            "
            @click="handleTagClick(item2)"
          >
            {{ item2.name }}
          </li>
        </ul>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="handleBack"
      >
        返 回
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomerApi from "@/utils/api/customer";
import { showLoadingToast, showFailToast, showSuccessToast } from "vant";

interface TagList {
  name: string;
  category_uuid: string;
  tags: Tag[];
}

interface Tag {
  name: string;
  tag_uuid: string;
}
// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { user_uuid } = route.query;
let state = reactive({
  isSubmit: false,

  tagLists: [] as TagList[],

  //   当前选中的标签
  currentTagIds: [] as Tag[],
  isChangeTag: false,
  changeTagLoading: null,
});

// --------------------------------------- 方法、事件
onMounted(() => {
  GroupService.getInfo();
  GroupService.getAllTagList();
});

// 点击标签
async function handleTagClick(row: Tag) {
  state.isChangeTag = true;
  state.changeTagLoading = showLoadingToast({
    message: "加载中...",
    forbidClick: true,
  });

  let index = state.currentTagIds.findIndex((v) => v === row.tag_uuid);
  let res = null;
  let operateName = "";
  if (index >= 0) {
    operateName = "取消绑定";
    state.currentTagIds.splice(index, 1);
    res = await CustomerApi._customerUnbindTag({
      admin_tag_uuid: row.tag_uuid,
      user_uuid,
    }).catch((err) => {});
  } else {
    operateName = "绑定标签";
    state.currentTagIds.push(row.tag_uuid);
    res = await CustomerApi._customerBindTag({
      admin_tag_uuid: row.tag_uuid,
      user_uuid,
    }).catch((err) => {});
  }
  if (res?.code === 200) {
    state.isChangeTag = false;
    state.changeTagLoading?.close();
    showSuccessToast(operateName + "成功！");
  } else {
    showFailToast(operateName + "失败！");
  }
}

function handleBack() {
  router.go(-1);
}
// --------------------------------------- 请求
const GroupService = {
  async getInfo() {
    let res = await CustomerApi._customerInfo({ user_uuid }).catch((err) => {});
    state.currentTagIds = res?.data?.user_tag_info?.tag_uuids?.split(",") || [];
  },
  async getAllTagList() {
    let res = await CustomerApi._customerTags().catch((err) => {});
    state.tagLists = res?.data || [];
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.tags {
  padding: 13px 14px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;

  &:not(:first-child) {
    margin-top: 13px;
  }

  ._categoryName {
    height: 28px;
    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .tagItem {
    height: 22px;
    line-height: 22px;
    padding: 0 13px;
    background: #f5f5f5;
    border-radius: 12px;
    margin-right: 12px;
    margin-top: 13px;

    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    text-align: justified;
    font-style: normal;
    text-transform: none;

    &.active {
      background: #dcbb89;
      color: #fff;
    }
  }
}
</style>
